import { create } from 'zustand'
import fetcher from "../fetcher";

export const useListDealsStore = create((set, get) => ({
    deals: [],
    has_more: true,
    current_page: 0,
    count: 0,

    isLoading: false,
    setIsLoading: (value) => set({isLoading: value}),

    search: "",
    setSearch: (value) => set({search: value}),

    fetchListDeals: async (params) => {
        set({isLoading: true})
        const response = await fetcher.getDeals(params)
        if (response?.data) {
            const { results, has_more, current_page, count } = response?.data

            if (current_page === 1) {
                set({
                    deals: results,
                    isLoading: false,
                    has_more: has_more,
                    current_page: current_page,
                    count: count
                })
            } else {
                const currentPage = get().current_page
                if (current_page !== currentPage) {
                    const currentList = get().deals

                    const newList = currentList.concat(results)
                    set({
                        deals: newList,
                        isLoading: false,
                        has_more: has_more,
                        current_page: current_page,
                        count: count
                    })
                }
            }
        }
    },

    shouldFetchNextDeals: () => {
        return !Boolean(get().isLoading) && Boolean(get().has_more)
    },

    removeDeletedDealFromList: (dealId) =>
        set((state) => ({
            deals: state.deals.filter((deal) => deal.id !== dealId),
        })),
}))